import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { MenuServices } from "../../../services";
import { Globals } from "../../../../../globals";
import { TranslateService } from '@ngx-translate/core';
/**
 * Generated class for the MenuPartialDishesSelectedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-menu-partial-dishes-selected',
    templateUrl: 'menu-partial-dishes-selected.html',
})
export class MenuPartialDishesSelectedPage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public menuServices: MenuServices,
        public globals: Globals,
        public translate: TranslateService) {
    }

    deleteElement(index) {
        if (index >= 0) {
            this.menuServices.menu_dish_array_tmp.splice(index, 1);
            this.menuServices.menu_dish_array_tmp = [...this.menuServices.menu_dish_array_tmp];
        }
    }

    reorderElements(indexes) {
        var element = this.menuServices.menu_dish_array_tmp[indexes.from];
        this.menuServices.menu_dish_array_tmp.splice(indexes.from, 1);
        this.menuServices.menu_dish_array_tmp.splice(indexes.to, 0, element);
    }
}



// WEBPACK FOOTER //
// ./src/pages/menu/menu-create/menu-create-dish-select/menu-partial-dishes-selected/menu-partial-dishes-selected.ts